export default __webpack_public_path__ + "static/media/icon-filter.2471816d.svg";